import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

const enterpriseIconWidth = '2.4rem';
const enterpriseArrowWidth = '1.6rem';

/**
 * EnterpriseMenu component styles
 * @returns {Function}
 */
export const useStyles = makeStyles((theme) =>
  createStyles({
    enterprise: {
      background: variables.colorV2.navigation.primary.background.default,
      borderRadius: '.8rem',
      boxShadow: '0 0.1rem 0.1rem rgba(0, 0, 0, 0.08)',
      padding: theme.spacing(0.875, 1, 0.875, 1),
      marginBottom: theme.spacing(2.875),
      border: `.2rem solid transparent`,
      transition: 'padding 0.3s ease',

      '& > *': {
        overflow: 'hidden',
        transition: 'width 0.3s ease, margin-left 0.3s ease',
      },

      '&$expanded': {
        boxShadow: '0 0.1rem 0 rgba(0, 0, 0, 0.03)',
        padding: theme.spacing(0.875, 1.5, 0.875, 1),

        '& $enterpriseText': {
          width: `calc(100% - ${enterpriseIconWidth} - ${enterpriseArrowWidth} - ${theme.spacing(1)})`,
          marginLeft: theme.spacing(1),
        },

        '& $enterpriseArrow': {
          width: enterpriseArrowWidth,
        },
      },

      '&:hover': {
        outline: `.2rem solid ${variables.colorV2.navigation.primary.border.hover}`,

        '& $enterpriseLabel': {
          color: variables.colorV2.navigation.primary.text.hover,
        },

        '& $enterpriseName': {
          color: variables.colorV2.navigation.primary.text.hover,
        },

        '& $enterpriseIcon': {
          stroke: variables.colorV2.navigation.primary.icon.stroke.hover,
        },

        '& $enterpriseArrow': {
          stroke: variables.colorV2.navigation.primary.icon.stroke.hover,
        },
      },
    },

    enterpriseText: {
      display: 'flex',
      width: 0,
      flex: '1 0 auto',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: 0,
    },

    enterpriseLabel: {
      fontSize: variables.font.size.xxxs,
      fontWeight: variables.font.weight.bold,
      color: 'rgba(144, 163, 200, 0.6)',
      lineHeight: variables.lineHeight.xxxs,
      textTransform: 'uppercase',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },

    enterpriseName: {
      fontSize: variables.font.size.md,
      fontWeight: variables.font.weight.semiBold,
      lineHeight: variables.lineHeight.lg,
      color: variables.color.primary.mediumPurple,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '100%',
    },

    enterpriseIcon: {
      width: enterpriseIconWidth,
      height: enterpriseIconWidth,
      stroke: variables.colorV2.navigation.primary.icon.stroke.default,
    },

    enterpriseArrow: {
      display: 'inline-flex',
      width: 0,
      stroke: variables.color.primary.mediumPurple,
    },

    enterpriseMenuPaper: {
      border: `.1rem solid ${variables.colorV2.popupMenu.border.default}`,
      borderRadius: '.8rem',
      boxShadow: 'unset',
      height: '18.6rem',
      marginTop: theme.spacing(0.5),
      paddingLeft: 0, //theme.spacing(1),
      paddingRight: 0, //theme.spacing(0.5),
      width: '22.4rem',

      '&.active': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        // borderRight: 'unset',
      },
    },

    enterpriseActiveSelection: {
      background: variables.colorV2.dropdown.list.background.active + ' !important',
      color: variables.colorV2.dropdown.list.text.active + ' !important',
    },

    businessUnitsMenuPaper: {
      borderRadius: '.8rem',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      border: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGray}`,
      boxShadow: 'unset',
      height: '18.6rem',
      marginLeft: '-0.7rem',
      marginTop: '1rem',
      // paddingLeft: '1rem',
      // paddingRight: '1rem',
      width: '22.4rem',
    },

    animatedWidth: {
      width: 0,
      minWidth: 0,
      overflow: 'hidden',
      transition: 'width 300ms cubic-bezier(0.4, 0, 0.2, 1), min-width 300ms cubic-bezier(0.4, 0, 0.2, 1) !important',

      '& $menuOpen': {},
    },

    menuOpen: {
      width: '22.4rem',
      minWidth: '22.4rem',
      overflowX: 'scroll',
    },

    businessUnitMenuItem: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },

    menuTitle: {
      margin: theme.spacing(0, 1, 0.5),
      padding: theme.spacing(1, 0),
      borderBottom: `.1rem solid ${variables.colorV2.popupMenu.option.border.default}`,
      borderRadius: 'unset',
      cursor: 'auto',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    menuItemTitle: {
      color: variables.colorV2.popupMenu.option.text.secondary,
      flex: '1 1 auto',
      fontSize: variables.font.size.sm,
      fontWeight: 400,
      lineHeight: variables.lineHeight.sm,
    },

    enterpriseMenuItem: {
      borderRadius: 0,
      color: variables.colorV2.popupMenu.option.text.default,
      minHeight: 'auto',
      padding: theme.spacing(1),

      '&$selected': {
        color: variables.colorV2.popupMenu.option.text.active,
        background: variables.colorV2.popupMenu.option.background.active,

        '& $enterpriseMenuItemIcon': {
          '& svg path': {
            stroke: variables.colorV2.popupMenu.option.icon.stroke.active,
          },
        },

        '& $businessUnitMenuItemIcon': {
          opacity: variables.opacity.full,
        },
      },

      '&$selected:hover': {
        color: variables.colorV2.popupMenu.option.text.hover,
        background: variables.colorV2.popupMenu.option.background.hover,
      },

      '&:hover': {
        color: variables.colorV2.popupMenu.option.text.hover,
        background: variables.colorV2.popupMenu.option.background.hover,
      },
    },

    enterpriseMenuItemText: {
      flex: '1 1 auto',
      fontSize: '1.3rem',
      fontWeight: 500,
      lineHeight: variables.lineHeight.lg,
    },

    enterpriseMenuItemIcon: {
      display: 'flex',
      alignItems: 'center',
    },

    businessUnitMenuItemIcon: {
      display: 'flex',
      alignItems: 'center',
      opacity: variables.opacity.none,
    },

    expanded: {},
    selected: {},
  }),
);
